module.exports = __webpack_public_path__ + "static/media/data_archive_repository.141dc98e.svg";